import { useParams } from "react-router-dom";
import i18n from "@/i18n";
import { AuditCard } from "@/features/Audit/AuditCard";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { C3TransactionsEditCard } from "./edit_card";
import { TechnicalInfoCard } from "@/components/TechnicalInfoCard";

const client = Clients.C3;
const table_name = Tables.C3_TRANSACTIONS;

export const C3TransactionsEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full relative">
      <div className="flex flex-col gap-10 p-10">
        <C3TransactionsEditCard
          id={Number(id)}
          client={client}
          table_name={table_name}
        />
        <TechnicalInfoCard
          id={Number(id)}
          table_name={table_name}
          client={client}
        />
        <AuditCard
          id={Number(id)}
          client={client}
          audit_table_name={table_name}
        />
      </div>
    </div>
  );
};
